import { apiClient } from "module/api";
import { Integration, INTEGRATIONS, INTEGRATIONS_STATUS } from "../dto";

const getAllClientConnectedIntegrations = async (clientId: number) => {
  try {
    const response = await apiClient.getClientIntegrations(clientId);
    const clientIntegrations = await response.json();
    const allClientIntegrations = await Promise.all(
      clientIntegrations.map(async (integration: string) => {
        const integrations = await apiClient.getIntegrations(clientId, integration as INTEGRATIONS);
        return integrations.json();
      })
    );
    return allClientIntegrations
      .flat()
      .filter((integration: Integration) => integration.connectionStatus !== INTEGRATIONS_STATUS.DISCONNECTED);
  } catch (error) {
    console.error(error);
    return [];
  }
};

export { getAllClientConnectedIntegrations };
